import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import utils from '../../utils'
import cartServices from '../../services/CartServices'
import Loading from '../../components/feedback/Loading'
import FetchError from '../../components/feedback/FetchError'
import Empty from '../../components/feedback/Empty'
import { Link } from 'react-router-dom'
import CheckoutSteps from '../../components/cart/CheckoutSteps'
import { useCart } from '../../context/CartContext'
import DeliveriInfoStage from '../../components/cart/DeliveriInfoStage'
import CompleteCheckout from '../../components/cart/CompleteCheckout'

function CheckoutPage() {
    const {
        numCartItems,
    } = useCart();
    const [stage, setStage] = useState(0)
    const [items, setItems] = useState([])
    const [cart, setCart] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const totalPrice = items.reduce((acc, item) => acc + parseFloat(item?.total || 0), 0);

    useEffect(() => {
        setLoading(true)
        setError()
        getCart()
        getItems()
    }, [])
    useEffect(() => { }, [stage])
    useEffect(() => { }, [cart])
    useEffect(() => { }, [items])

    const getItems = async () => {
        cartServices.getCartItems().then(
            res => {
                setItems(res.data)
            },
            err => {
                setError(err)
            }
        )
    }
    const getCart = () => {
        cartServices.checkCart().then(
            res => {
                setCart(res.data)
                setLoading(false)
            },
            err => {
                setError(err)
                setLoading(false)
            }
        )
    }
    return (
        <div>
            <Helmet>
                <title>Checkout - {utils.siteName}</title>
                <meta name="description" content="Add your delivery information." />
                <meta name="robots" content="noindex" />
            </Helmet>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <div className="mb-6">
                    <h1 className="text-4xl font-black text-primary dark:text-secondary">
                        {stage === 0 && "Delivery"}
                        {stage === 1 && "Payment"}
                    </h1>
                </div>
                <hr className='mb-6' />
                {loading ? (
                    <div className="flex justify-center">
                        <Loading />
                    </div>
                ) : (
                    <div>
                        {error ? (
                            <FetchError error={error} />
                        ) : (
                            <div>
                                {!items?.length ? (
                                    <div className="">
                                        <Empty objectName="Cart Items" />
                                        <div className="text-center mt-6">
                                            <Link
                                                to="/products"
                                                className="inline-block px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-red-800 transition"
                                            >
                                                Continue Shopping
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <CheckoutSteps stage={stage} />

                                        {stage === 0 && (
                                            <DeliveriInfoStage
                                                cart={cart}
                                                numCartItems={numCartItems}
                                                totalPrice={totalPrice}
                                                setStage={setStage}
                                                setCart={setCart}
                                            />
                                        )}
                                        
                                        {stage === 1 && (
                                            <CompleteCheckout
                                                cart={cart}
                                                getCart={getCart}
                                                numCartItems={numCartItems}
                                                totalPrice={totalPrice}
                                                setStage={setStage}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CheckoutPage